import { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import Icon from './Icon';

export default function ModuleImage ({moduleImage, moduleIndex, saveModuleImage, hideModuleImage}) {

    console.log('moduleImage');
    console.log(moduleImage);

    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const saveButton = (data) => {

	    console.log(image);

        saveModuleImage (image, moduleIndex);
        hideModuleImage ();
    }

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    useEffect(() => {

        if (moduleImage){
            setImageUrl(moduleImage);
			setImage(moduleImage);
		}

	}, [moduleImage]);

	const defaultImages = {
		loсked: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/modules%2Fmodule-locked.png?alt=media&token=df1e5743-e2ba-479a-8276-cb0006bd8502',
		unlocked: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/modules%2Fmodule-unlocked.png?alt=media&token=5eae706b-d4d6-4b48-934a-758aaa79201b',
		completed: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/modules%2Fmodule-completed.png?alt=media&token=4ce4b706-ce8c-4e43-8312-3d89c0970d44',
	};
	const [image, setImage] = useState(defaultImages);
	const [imageUrl, setImageUrl] = useState(defaultImages);

    const saveIcon = (file, type) => {

		console.log(file)
		console.log(type);

		let temp = Object.assign([], image);
		temp[type] = file;
        setImage(temp);

        const objectUrl = URL.createObjectURL(file);

		if (!moduleImage)
			moduleImage = [];
		moduleImage[type] = objectUrl;

		temp = Object.assign([], imageUrl);
		temp[type] = objectUrl;
        setImageUrl(temp);

    }

    const hideIcon = (event) => {
    }

    return (

	<div className="right right_module_image texts">
	    <div className="dashed-border">
		<div className="title">
		    <div>
				<div className="name">
					Module image
					<div className="subname">Size 84 x 84</div>
				</div>
		    </div>
		    <div>
				<div className="cancel" onClick={hideModuleImage}>
					<Cancel/>
				</div>
		    </div>
		</div>

		<form id="moduleImage" className="module_image">

			<div className="subtitle">Loсked</div>
			<Icon index="loсked" icon={imageUrl['loсked'] ? imageUrl['loсked'] : ''} saveIcon={saveIcon} hideIcon={hideIcon} size="512"/>

			<div className="subtitle">Unlocked</div>
			<Icon index="unlocked" icon={imageUrl['unlocked'] ? imageUrl['unlocked'] : ''} saveIcon={saveIcon} hideIcon={hideIcon} size="512"/>

			<div className="subtitle">Completed</div>
			<Icon index="completed" icon={imageUrl['completed'] ? imageUrl['completed'] : ''} saveIcon={saveIcon} hideIcon={hideIcon} size="512"/>

			<div className="subtitle"></div>

			<button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
				Save
			</button>
			<div className="error">{ message }</div>

		</form>

	    </div>

	</div>

    )

}
